__turbopack_context__.v({
  "advantages": "AupXIa_advantages",
  "backgroundContainer": "AupXIa_backgroundContainer",
  "body": "AupXIa_body",
  "companyValues": "AupXIa_companyValues",
  "description": "AupXIa_description",
  "firstScreenDescription": "AupXIa_firstScreenDescription",
  "firstSection": "AupXIa_firstSection",
  "pageTitle": "AupXIa_pageTitle",
  "partnerButtons": "AupXIa_partnerButtons",
  "partners": "AupXIa_partners",
  "partnersTitle": "AupXIa_partnersTitle",
  "processes": "AupXIa_processes",
  "reviewWidget": "AupXIa_reviewWidget",
  "team": "AupXIa_team",
  "title": "AupXIa_title",
  "withBorderBottom": "AupXIa_withBorderBottom",
});
